import React from 'react'
import RoleLabel from '../role-label'
import { Pencil } from 'react-bootstrap-icons'

const ViewRole = ({
    user = {},
    onEdit = () => {},
    disabled
}) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
                <RoleLabel user={user} />
            </div>
            <div>
                {!disabled && <div style={{ cursor: 'pointer' }} onClick={() => onEdit()} ><Pencil /></div>}
            </div>
        </div>
    )
}

export default ViewRole